import React from 'react';
import { ChartDataset } from 'chart.js';
import FloatingBarsChart from '../../../../../Components/Chart/FloatingBarsChart';
import useTranslation from '../../../../../Hooks/useTranslation';
import { useAppContext } from '../../../../../Services/AppContext';
import useCurrency from '../../../../Region/Hooks/useCurrency';

type ITranslation = (
	key: string | undefined,
	params?: any,
) => string | undefined;

const getDefaultOptions = (t: ITranslation, currency: string) => ({
	responsive: true,
	maintainAspectRatio: false,
	plugins: {
		legend: {
			labels: { usePointStyle: true },
			position: 'top' as const,
			align: 'end',
			font: {
				size: 14,
			},
		},
		title: {
			display: true,
			text: t('component.invoicing.invoicingOverall'),
			position: 'top',
			align: 'start',
			font: {
				size: 16,
			},
			padding: {
				top: 20,
			},
		},
		tooltip: {
			callbacks: {
				label: function (context: any) {
					return currency + ' ' + context.dataset.data[context.dataIndex];
				},
			},
		},
	},
	scales: {
		x: {
			stacked: true,
			ticks: {
				color: '#97a4ba',
				fontSize: 14,
				beginAtZero: true,
			},
			grid: {
				borderDash: [10, 4],
				color: '#edf1f4',
				offset: true,
			},
		},
		y: {
			stacked: false,
			ticks: {
				color: '#97a4ba',
				fontSize: 14,
				beginAtZero: true,
				gridLines: {
					borderDash: [10, 4],
					color: '#348632',
				},
				callback: (value: string) => value,
			},
			grid: {
				borderDash: [10, 4],
				color: '#edf1f4',
			},
		},
	},
});

type ILabelsAcc = {
	array: number[];
	iteration: number;
};

interface Props {
	datasets: ChartDataset<'bar', number[]>[];
	labels: string[];
}

const InvoicingChart: React.FC<Props> = ({ datasets = [], labels = [] }) => {
	const { currencyCode } = useCurrency();
	const { t } = useTranslation();
	return (
		<FloatingBarsChart
			options={getDefaultOptions(t, currencyCode)}
			data={{
				datasets,
				labels,
			}}
		/>
	);
};

export default InvoicingChart;
